import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { AuditionType } from 'shared/enums/AuditionType';
import { useAxios } from 'shared/hooks/useAxios';
import {
  ICreateRoleResponsePayload,
  IRoleCreatePayload,
  IRoleResponsePayload,
  IRoleSideCreatePayload,
  IRoleSideCreateResponsePayload,
  ISingleRoleResponsePayload,
} from 'shared/interfaces/IRole';

const { GET, POST } = useAxios();
export const roleDao = () => {
  const getRoles = async (projectId: string, auditionType?: AuditionType) => {
    const response = await GET<IRoleResponsePayload>({
      url: `${ENDPOINTS.PROJECT}/${projectId}/roles`,
      params: {
        audition_type: auditionType,
      },
    });
    return response.data;
  };

  const getSingleRole = async (projectId: string, roleId: string) => {
    const response = await GET<ISingleRoleResponsePayload>({
      url: `${ENDPOINTS.PROJECT}/${projectId}/roles/${roleId}`,
    });
    return response.data;
  };

  const createRole = async (projectId: string, payload: IRoleCreatePayload) => {
    const response = await POST<ICreateRoleResponsePayload>({
      url: `${ENDPOINTS.PROJECT}/${projectId}/roles`,
      data: payload,
    });

    return response.data;
  };

  const createRoleSide = async (projectId: string, roleId: string, payload: IRoleSideCreatePayload) => {
    const response = await POST<IRoleSideCreateResponsePayload>({
      url: `${ENDPOINTS.PROJECT}/${projectId}/roles/${roleId}/sides`,
      data: payload,
    });
    return response.data;
  };

  return {
    getRoles,
    getSingleRole,
    createRole,
    createRoleSide,
  };
};
